import {
  APP_RECORD_TYPES,
  AppRecordType,
  isHiddenRecordType,
  ReportingItem,
} from "vmd-types";

// Single switch for record-type visibility: flip HIDDEN_APP_RECORD_TYPES in vmd-types.
export const isRecordTypeVisible = (recordType: AppRecordType): boolean =>
  !isHiddenRecordType(recordType);

const normalizeRecordType = (value: string | undefined) =>
  (value ?? "").trim().toLowerCase();

const RECORD_TYPE_ALIASES = new Map<AppRecordType, Set<string>>([
  [
    APP_RECORD_TYPES.IT_SERVICE,
    new Set([normalizeRecordType(APP_RECORD_TYPES.IT_SERVICE)]),
  ],
  [
    APP_RECORD_TYPES.BUSINESS_APPLICATION,
    new Set([normalizeRecordType(APP_RECORD_TYPES.BUSINESS_APPLICATION)]),
  ],
]);

const isMatchingRecordType = (
  actualRecordType: string | undefined,
  targetRecordType: AppRecordType
) => {
  const normalizedActual = normalizeRecordType(actualRecordType);
  const aliases = RECORD_TYPE_ALIASES.get(targetRecordType);

  if (aliases) {
    return aliases.has(normalizedActual);
  }

  return normalizedActual === normalizeRecordType(targetRecordType);
};

export const filterReportingItemsByRecordType = (
  reportingItems: ReportingItem[] | undefined,
  recordType: AppRecordType
): ReportingItem[] => {
  return (reportingItems ?? []).filter(
    (item) =>
      !item?.isChannelHeader &&
      isMatchingRecordType(item?.basicItem?.recordType, recordType)
  );
};

export const countReportingItemsByRecordType = (
  reportingItems: ReportingItem[] | undefined,
  recordType: AppRecordType
): number =>
  filterReportingItemsByRecordType(reportingItems, recordType).length;
